import { h2, paragraph } from "@/styles/typography";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  padding: 50px 40px 100px 40px;
  background-color: ${({ theme }) => theme.colors.pearlBush};
  height: 100%;

  overflow: hidden;

  @media screen and (max-width: 820px) {
    padding: 50px 0 100px 0;
  }

  @media screen and (max-width: 992px) {
    padding: 18px 0 100px 0;
  }
`;

const FooterInner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  @media screen and (max-width: 992px) {
    flex-direction: column;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  width: 100%;
  z-index: 1;

  @media screen and (max-width: 992px) {
    gap: 24px;
  }
`;

const AnimationWrapper = styled.div`
  display: flex;
  width: 100%;
  @media screen and (max-width: 992px) {
    margin: 0 auto;
  }

  .bang1 {
    width: 150px;
  }
`;

const Animation = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  @media screen and (max-width: 992px) {
    height: 540px;
    margin: 50px 0;
    max-width: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateX(100px);
  }

  @media screen and (max-width: 650px) {
    transform: translateX(50px);
  }

  @media screen and (max-width: 500px) {
    transform: translateX(0px);
  }

  @media screen and (max-width: 450px) {
    transform: translateX(-50px);
  }

  .animation-part {
    position: absolute;
    width: calc(350px * 1.4);
    z-index: 0;
  }

  .part1 {
    left: 20%;
    bottom: -40%;
    animation: float 30s linear infinite;
    @media screen and (max-width: 992px) {
      left: 0%;
      bottom: -20%;
    }
  }

  .part2 {
    left: -20%;
    top: 10%;
    animation: float 45s linear reverse infinite;
    @media screen and (max-width: 992px) {
      left: -20%;
      top: 20%;
    }
  }

  .part3 {
    left: 50%;
    top: -38%;
    animation: float 50s linear reverse infinite;
  }

  .part4 {
    left: 10%;
    top: 1%;
    animation: float 30s linear reverse infinite;
  }

  .part5 {
    left: 35%;
    top: 5%;

    animation: float 45s linear infinite;
  }

  .part6 {
    left: 40%;
    bottom: -20%;
    animation: float 50s linear infinite;
  }

  .part7 {
    left: -20%;
    top: -40%;
    animation: float 30s linear infinite;
  }

  .part8 {
    left: 20%;
    top: -42%;
    animation: float 40s linear infinite;
    @media screen and (max-width: 992px) {
      left: 0%;
      top: -15%;
    }
  }

  @keyframes float {
    0% {
      transform: translate(0px, 0px) rotate(0deg);
    }
    8% {
      transform: translate(20px, 20px) rotate(25deg);
    }
    16% {
      transform: translate(40px, 40px) rotate(50deg);
    }
    24% {
      transform: translate(50px, 50px) rotate(75deg);
    }
    32% {
      transform: translate(40px, 60px) rotate(100deg);
    }
    40% {
      transform: translate(20px, 80px) rotate(125deg);
    }
    48% {
      transform: translate(0px, 100px) rotate(150deg);
    }
    56% {
      transform: translate(-20px, 80px) rotate(175deg);
    }
    64% {
      transform: translate(-40px, 60px) rotate(200deg);
    }
    72% {
      transform: translate(-50px, 50px) rotate(225deg);
    }
    80% {
      transform: translate(-40px, 40px) rotate(250deg);
    }
    88% {
      transform: translate(-30px, 30px) rotate(275deg);
    }
    92% {
      transform: translate(-20px, 20px) rotate(300deg);
    }
    96% {
      transform: translate(-10px, 10px) rotate(330deg);
    }
    100% {
      transform: translate(-0px, 0px) rotate(360deg);
    }
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled(h2)`
  margin-bottom: 17px;
  font-size: 35px;
  color: ${({ theme }) => theme.colors.tango};
`;

const ContactWrapper = styled.div`
  display: flex;
  grid-gap: 50px;

  @media screen and (max-width: 820px) {
    flex-direction: column;
    grid-gap: 0;
  }
`;

const Contact = styled.div`
  display: flex;
  flex-direction: column;
`;

const Text = styled(paragraph)`
  margin-bottom: 5px;

  a {
    text-overflow: wrap;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.softBlack};
    cursor: pointer;
  }
`;

const TextBold = styled(Text)`
  font-weight: bold;
`;

const SocialMediaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const SocialMediaLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

const SocialMediaLink = styled.a`
  font-family: sans-serif;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.softBlack};
  margin-bottom: 5px;
`;

const S = {
  Container,
  Wrapper,
  AnimationWrapper,
  Animation,
  FooterSection,
  Title,
  ContactWrapper,
  Contact,
  Text,
  TextBold,
  SocialMediaWrapper,
  SocialMediaLinkWrapper,
  SocialMediaLink,
  FooterInner,
};

export default S;
